import React, { useEffect, useState } from 'react'
//import Breadcrumbs2 from 'components/Breadcrumbs2'
import Drawer from 'react-modern-drawer'
import { useDispatch, useSelector } from 'react-redux'
import { useRequest } from 'hooks/useRequest'
import { currentLocationFunc, updateAddressFunc } from 'redux/features/general/generalSlice'
import AddressCard from 'components/address/AddressCard'
import images from 'assets/images/images'
import AddressAddDrawer from 'components/address/AddressAddDrawer'
import LoaderTwo from 'pages/LoaderTwo'
import useFilterSearch from 'hooks/useFilterSearch'
import useTranslate from 'hooks/useTranslate'

const StageAddAddresses = ({forHome, setRegisterState}) => {
    const [isOpenDrawer, setIsOpenDrawer] = useState(false)
    const [getAddress,setGetAddress] = useState([])
    const [request, loading] = useRequest();
    const [filteredAddresses, handleFilterChange, setFilteredAddresses] = useFilterSearch(getAddress)

    const {useTrigger} = useSelector(state => state.general)
    const dispatch = useDispatch();
    const {t} = useTranslate()

    const [addressInfo, setAddressInfo] = useState({
        firstName: "",
        lastName: "",
        addressTitle: "",
        province: "",
        provinceId: null,
        district: "",
        districtId: null,
        neighbourhood: "",
        neighbourhoodId: null,
        street: "",
        streetId: null,
        building: "",
        buildingId: null,
        floor: "",
        apartment: "",
        addressDescription: "",
        latitude: null,
        longitude: null,
        countryCode: "",
        phone: ""
      })

    useEffect(() => {
         request('/Profile/Addresses', {
            method: "GET"
         })
         .then((res) => {
            if(res){
               setGetAddress(res.data.result)  
               setFilteredAddresses(res.data.result)
            }
         } )
    }, [useTrigger])


    const addAddressDrawer = () => {
        //buraya farklı kısımlar gelecek....
        dispatch(currentLocationFunc({}))
        dispatch(updateAddressFunc({}))
        setAddressInfo({})
        setIsOpenDrawer(!isOpenDrawer)
    }
    return (
        <div className={`address-bgColor`}>
            <LoaderTwo isDataLoading={loading} />
            <div className='address'>
                {/* <Breadcrumbs2 smallText={'ANA SAYFA /'} largeText={'Adreslerim'} /> */}
                <div className="address-container">
                    {
                        getAddress.length > 0 && <input type="text" onChange={(e) => handleFilterChange(e.target.value)} placeholder={t('searchInAddresses')} className="form-control-input" />
                    }
                    {
                        filteredAddresses.map((item, i) => (
                            <AddressCard setRegisterState={setRegisterState} forHome={forHome} key={i} item={item} setIsOpenDrawer={setIsOpenDrawer} isOpenDrawer={isOpenDrawer} />
                        ))
                    }
                    
                    <div onClick={addAddressDrawer} className='address-container-btn'>
                        <img src={images.plus2} alt="" />
                        <div>{t('addAddress')}</div>
                    </div>
                </div>

                <Drawer
                    open={isOpenDrawer}
                    onClose={() => setIsOpenDrawer(!isOpenDrawer)}
                    direction='right'
                    className='addressAddDrawer'
                >
                    <AddressAddDrawer isOpenDrawer={isOpenDrawer} forHome={forHome} setRegisterState={setRegisterState} addressInfo={addressInfo} setAddressInfo={setAddressInfo} setIsOpenDrawer={setIsOpenDrawer} />
                </Drawer>
            </div>
        </div>
    )
}

export default StageAddAddresses